import {
  Card,
  CardHeader,
  CardBody,
  User,
  Progress,
  Checkbox,
} from "@heroui/react";
import React from "react";

import { ReactComponent as ChevronDownIcon } from "@wc/ui/assets/icons/chevron-down.svg";

/**
 * Read-only win card component for team view
 * @param {object} props Component props
 * @param {string} props.displayName User's display name
 * @param {string|null} props.photoURL User's photo URL
 * @param {Array} props.goals Array of goal objects
 * @param {object} props.progress Progress information
 * @returns {React.ReactElement} Read-only win card
 */
export default function WinCardReadonly({
  displayName,
  photoURL,
  goals = [],
  progress = { completed: 0, total: 5 },
}) {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const progressValue =
    progress.total > 0 ? (progress.completed / progress.total) * 100 : 0;

  return (
    <Card
      isPressable
      onPress={() => setIsExpanded(!isExpanded)}
      className="mb-4 w-full"
    >
      <CardHeader className="flex items-center justify-between gap-4">
        <User
          name={displayName}
          avatarProps={{
            src: photoURL,
            showFallback: true,
          }}
        />
        <div className="flex items-center gap-2">
          <Progress
            size="md"
            value={progressValue}
            color={
              progress.completed === progress.total ? "success" : "primary"
            }
            className="w-48"
            showValueLabel={false}
          />
          <span className="text-default-600 min-w-[40px] text-sm">
            {progress.completed}/{progress.total}
          </span>
          <ChevronDownIcon
            className={`size-5 shrink-0 transition-transform ${isExpanded ? "rotate-180" : ""}`}
          />
        </div>
      </CardHeader>

      {isExpanded && (
        <CardBody>
          {goals.length === 0 ? (
            <p className="text-default-400 text-sm italic">No goals set yet</p>
          ) : (
            <div className="space-y-2">
              {goals.map((goal) => (
                <div key={goal.id} className="flex items-center gap-2">
                  <Checkbox isSelected={goal.completed} isDisabled size="lg" />
                  <span
                    className={`text-sm font-semibold ${goal.completed ? "text-default-400 line-through" : ""}`}
                  >
                    {goal.text}
                  </span>
                </div>
              ))}
            </div>
          )}
        </CardBody>
      )}
    </Card>
  );
}
